import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { loginGenerator } from 'store/login-user/LoginUserData';
import { FormErrors } from 'validators/LoginValidator';
import { LoginParameters } from 'components/templates/LoginTemplate';
import { Store } from 'store/Store';
import { ActionBase } from 'store/ActionBase';
import { RoutePath } from 'consts/RoutePath';

/**
 * ログイン処理のカスタムフック
 * フォームバリデーション -> ログイン実処理 -> ページ遷移 を段階的に分けている
 * useStateが非同期なのでuseEffectを使って段階的にしないとエラーをキャッチすることができないため
 */
export const useLogin = (
	formErrors: FormErrors,
	setFormErrors: React.Dispatch<React.SetStateAction<FormErrors>>,
	getErrorMessage: Function,
	loginParameters: LoginParameters,
	store: Store,
	dispatch: React.Dispatch<ActionBase>,
	setProcessLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
	// フォームバリデーション
	const [isFormValidationFinished, setIsFormValidationFinished] = useState(false);
	const login = async () => {
		setProcessLoading(true);

		Object.keys(formErrors).forEach((k) => {
			setFormErrors((prev) => ({ ...prev, [k]: getErrorMessage(k, loginParameters[k]) }));
		});
		setIsFormValidationFinished(true);
	};

	// ログイン実処理
	const [isLoginFinished, setIsLoginFinished] = useState(false);
	useEffect(() => {
		if (!isFormValidationFinished) {
			return;
		}

		const isError = !!Object.values(formErrors).find((e) => e !== '');
		if (isError) {
			setIsFormValidationFinished(false);
			setProcessLoading(false);
			return;
		}

		const executeLogin = async () => {
			await loginGenerator(dispatch, loginParameters.gakkenId, loginParameters.password);
			setIsLoginFinished(true);
		};
		executeLogin();
	}, [isFormValidationFinished]);

	// ページ遷移
	const history = useHistory();
	useEffect(() => {
		if (!isLoginFinished) {
			return;
		}

		const isError = store.loginUserData.actionError !== '';
		if (isError) {
			setIsFormValidationFinished(false);
			setIsLoginFinished(false);
			setProcessLoading(false);
			return;
		}

		if (store.loginUserData.isErrorRedirect) {
			history.push(RoutePath.ERROR);
			return;
		}

		if (store.loginUserData.isRedirect) {
			history.push(`${RoutePath.TERMS}?from=login&isFirstAgreement=${store.loginUserData.isFirstAgreement}`);
			return;
		}

		history.push(RoutePath.MY_PAGE);
	}, [isLoginFinished]);

	return {
		login,
	};
};
